export interface Message {
    id: number;
    messageType: MessageType;
    createdDate?: Date;
    appComponentName: AppComponentName;
    appComponentItem: string;
    actionType: MessageActionType;
    details: string;
    userNotes: string;
    count: number;
    acknowledged: boolean;
    userGroupId: number;
    userName: string;
}

export interface MessageInfo {
    id: number;
    messageType: number;
    createdDate?: Date;
    appComponentName: number;
    appComponentItem: string;
    actionType: number;
    details: string;
    userNotes: string;
    count: number;
    acknowledged: boolean;
    userGroupId: number;
    userName: string;
}

export enum MessageType {
    Audit = 'Audit',
    Alert = 'Alert'
}

export enum AppComponentName {
    Dashboard = 'Dashboard',
    Sensors = 'Sensors',
    UserGroups = 'User Groups',
    Devices = 'Devices',
    SensorGroups = 'Sensor Groups',
    EventAndActions = 'Event and Actions',
    Charts = 'Charts',
    Users = 'Users',
    Imports = 'Imports',
    ActionQueues = 'Action Queues'
}

export enum MessageActionType {
    New = 'New',
    Edited = 'Edited',
    Deleted = 'Deleted',
    Message = 'Message',
    Email = 'Email'
}

export class MessageSearchCriteria {
    username: string;
    startDate: Date;
    endDate: Date;
}

export class MessageNotesSearchCriteria {
    userGroupId: number;
    category: string;
}

export class MessageNoteInfo {
    id: number;
    userGroupId: number;
    category: string;
    title: string;
    note: string;
}

export enum MessageNoteCategory {
    EventThreshold = 'EventThreshold',
    EventTrigger = 'EventTrigger',
    EventEdit = 'EventEdit',
    EventEditGroup = 'EventEditGroup'
}